<template lang="pug">
#sidebar
    el-menu.menu(
        default-active='0'
        background-color='var(--primary-white)'
        text-color='#434343'
        active-text-color='var(--primary)'
        ref='menu'
    )
        el-menu-item.menu-item(
            v-for='(item, i) in items',
            :id='"item" + i',
            :key='i',
            :index='i.toString()'
            @click='redirecionarMenu(item.link)'
        )
            .opcao-menu.mdi(:class='item.icon')
                a.title {{ item.title }}

    .modal-page
        slot
</template>

<script>
import { items } from '@/utils/sidebar.utils';

export default {
    name: 'SidebarComponent',

    data: () => ({
        item: 0,
        items,
    }),
    watch: {
        '$route.path'(path) {
            const indexItemSelecionado = this.items.findIndex(item => item.link === path);
            if (indexItemSelecionado !== -1) {
                this.$refs.menu.activeIndex = indexItemSelecionado.toString();
            }
        }
    },
    mounted() {
        const usuario = this.$eu();
        this.items = this.items.filter((element) => element.perfis.includes(usuario.perfil));
        
        const indexItemSelecionado = this.items.findIndex(item => item.link === this.$route.path);
        this.$refs.menu.activeIndex = indexItemSelecionado.toString();
    },
    methods: {
        redirecionarMenu(path) {
            if (this.$route.path !== path) {
                this.$router.push({ path })
            }
        }
    }
};
</script>

<style scoped>
#sidebar {
    display: flex;

    margin: 20px 25px 25px 40px;
    height: 95%;

    font-size: 12px;
    color: black;
}

.menu {
    padding: 16px;
    min-width: 239px
}

.menu-item {
    margin: 2px 0;

    display: flex;
    align-items: center;

    background-color: var(--primary-white);
    height: 50px;
    text-align: left;
    font-weight: bolder;
}

.opcao-menu {
    display: flex;
}

.title {
    font-size: 14px;
    margin-left: 10px;
}

.menu-item:hover {
    color: #3AAA1B !important;
    background-color: var(--primary-white) !important;
}

.modal-page {
    margin-left: -1px;
    width: 100%;
    height: 95%;
    overflow-y: auto;
    border: 15px solid var(--primary-white);

    background-color: var(--primary-white);
    /* border: 1.5px solid var(--primary-light-smoke) !important; */
}

.modal-page::-webkit-scrollbar {
    width: 8px;
}

.modal-page::-webkit-scrollbar-track {
    background-color: var(--primary-smoke);
}

.modal-page::-webkit-scrollbar-thumb {
    border-radius: 100px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
</style>
    